import React from 'react'
import HeroBgAnimation from '../HeroBgAnimation'
import { HeroContainer, HeroBg, HeroLeftContainer, Img, HeroRightContainer, HeroInnerContainer, TextLoop, Title, Span, SubTitle, ResumeButton } from './HeroStyle'
import HeroImg from '../../images/HeroImage.jpeg'
import Typewriter from 'typewriter-effect';
import { Bio } from '../../data/constants';

import { SiLeetcode } from "react-icons/si";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";


const HeroSection = () => {
    return (
        <div id="about">
            <HeroContainer>
                <HeroBg>
                    <HeroBgAnimation />
                </HeroBg>
                <HeroInnerContainer >
                    <HeroLeftContainer id="Left">
                        <Title>Hi, I am <br /> <Span>{Bio.name}</Span></Title>
                        <TextLoop>
                            I am a
                            <Span>
                                <Typewriter
                                    options={{
                                        strings: Bio.roles,
                                        autoStart: true,
                                        loop: true,
                                    }}
                                />
                            </Span>
                        </TextLoop>
                        <SubTitle>{Bio.description}</SubTitle>

                        <div style={{ marginBottom: "15px"}}>
                            <a href={Bio.linkedin} target="_blank"  >
                                <LinkedInIcon style={{fontSize: "40px", color: "white",  marginRight: "25px" }} />
                            </a>
                            <a href={Bio.leetcode} target="_blank"  >
                                <SiLeetcode style={{fontSize: "40px", color: "white",  marginRight: "25px"}} />
                            </a>
                            <a href={Bio.github} target="_blank"  >
                                <GitHubIcon style={{fontSize: "40px", color: "white", marginRight: "25px"}} />
                            </a>
                            <a href={Bio.insta} target="_blank"  >
                                <InstagramIcon style={{fontSize: "40px", color: "white"}} />
                            </a>
                        </div>

                        <ResumeButton href={Bio.resume} target='display'>Check Resume</ResumeButton>
                    </HeroLeftContainer>

                    <HeroRightContainer id="Right">

                        <Img src={HeroImg} alt="hero-image" />
                    </HeroRightContainer>

                </HeroInnerContainer>
            </HeroContainer>
        </div>
    )
}

export default HeroSection